import { RequestHelper } from "../../../../Lib/Helper/RequestHelper";
import { CrossSaleRequestHelper } from "../../../../Lib/Helper/AxProdSelection/CrossSaleRequestHelper";
import { CrossSaleSelectionHelper, ICrossSaleSelectionOptions } from "../../../../Lib/Helper/AxProdSelection/CrossSaleSelectionHelper";
import { ForeignCurrencyPriceHelper } from "../../../../Lib/Helper/ForeignCurrencyPriceHelper";
import { RentDetailsProdSelectionAbstract } from "./RentDetailsProdSelectionAbstract";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";
import { RentDetailsSingleItemSelectionSection } from
    "../../../../Models/Rental/Details/RentDetailsSingleItemSelectionSection";

export class RentDetailsProdSelectSingleItemHandler extends RentDetailsProdSelectionAbstract {

    private rentalDetailSingleSelectionItem: RentDetailsSingleItemSelectionSection[] = [];

    // cross-sale offer: maximum total quantity and discount of the displayed total (see CrossSaleSelectionHelper)
    private crossSaleOptions: ICrossSaleSelectionOptions;

    constructor(prodSelectionTimings: RentalProdSelectionTimings, pricesPerPersonType: any, foreignCurrencyHelper?: ForeignCurrencyPriceHelper,
        crossSaleOptions?: ICrossSaleSelectionOptions) {
        super(prodSelectionTimings);

        this.crossSaleOptions = crossSaleOptions;

        const rentalProductPortlets = document.getElementsByClassName('rental_details__product_portlet');

        for (let i = 0; i < rentalProductPortlets.length; i++) {
            const wrapperElement = rentalProductPortlets[i] as HTMLElement;
            const rentalPackSelection = new RentDetailsSingleItemSelectionSection(wrapperElement, pricesPerPersonType, foreignCurrencyHelper,
                () => this.limitCrossSaleQuantity());
            this.rentalDetailSingleSelectionItem.push(rentalPackSelection);
        }

        this.limitCrossSaleQuantity();
    }

    getSelectionTotalPrice(): number {
        let selectionTotalPrice = 0;

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            const selectionComp: RentDetailsSingleItemSelectionSection = this.rentalDetailSingleSelectionItem[i];
            const packPriceTotal = selectionComp.getSectionTotalPrice();
            selectionTotalPrice += packPriceTotal;
        }

        // cross-sale discount of the first selected item (the shopping cart discounts only one), not in the item prices
        const firstSelected = this.rentalDetailSingleSelectionItem.find(x => x.getItemsSelectedCount() > 0);
        if (firstSelected) {
            selectionTotalPrice -= CrossSaleSelectionHelper.getDiscount(firstSelected.getBasePrice(), this.crossSaleOptions?.CrossSaleDiscountPercent);
        }

        return selectionTotalPrice;
    }

    private limitCrossSaleQuantity() {
        CrossSaleSelectionHelper.limitTotalQuantity(
            this.rentalDetailSingleSelectionItem.map(x => x.counter),
            this.rentalDetailSingleSelectionItem.map(x => x.maxCount),
            this.crossSaleOptions?.CrossSaleMaxQuantity);
    }

    getAllProductsCount(): number {
        let selectionTotalCount = 0;

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            const selectionComp: RentDetailsSingleItemSelectionSection = this.rentalDetailSingleSelectionItem[i];
            selectionTotalCount += selectionComp.getItemsSelectedCount();
        }

        return selectionTotalCount;
    }

    protected createPostData(): any {

        let tempArr = [];

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            let tempItem = this.rentalDetailSingleSelectionItem[i];

            if (tempItem.getItemsSelectedCount() < 1) {
                continue;
            }

            const postData = tempItem.getPostData();
            tempArr.push(postData);
        }

        const data = {
            selectedLocationId: this.getSelectedLocationId(),
            startSoapDate: this.prodSelectionTimings.startSoapDate,
            durationIdentifier: this.prodSelectionTimings.durationIdentifier,
            pickupTimeId: this.prodSelectionTimings.pickUpTimeId,
            SelectedItems: tempArr
        };

        return data;
    }

    proceed() {

        const data = this.createPostData();
        const requestHelper = new RequestHelper();
        // keep the cross-sale reference of a shopping cart offer, it is sent with the add to cart of the rider details page
        requestHelper.postToUrl(`/${cultureInfo}/RentalRiderDetails/RiderDetailsSingle${CrossSaleRequestHelper.getQueryString()}`, data, {});

    }
}